import React from "react";
import "./activityLog.css";
import ProfileWithLIneIcon from "../../assets/images/profileWithLine.svg";

const ActivityLog = ({ name, date, time, activityMessage }) => {
  return (
    <div className="singleActivity">
      <div>
        <img
          className="profileWithLineIcon"
          src={ProfileWithLIneIcon}
          alt="Profile icon"
        />
      </div>
      <div className="activityLogDetails">
        <div className="nameContainer">{name}</div>
        <div className="dateContainer">
          {date} {time}
        </div>
        <div className="activityMessage">{activityMessage}</div>
      </div>
    </div>
  );
};

export default ActivityLog;
